<template>
  <v-container>
    <OverlayLoader :overlay="true" :text="'로그인 중'" />
  </v-container>
</template>
<script>
import OverlayLoader from "@/components/OverlayLoader.vue";
export default {
  name: "Division",
  components: {
    OverlayLoader,
  },
  methods: {
    division() {
      // this.$axios.get("/users/division").then((response) => {
      //   var code = window.localStorage.getItem("code");

      //   if (response.data === false) {
      //     if (code) {
      //       this.$router.push("/invited?code=" + code);
      //     } else {
      //       this.$router.push("/tutorial");
      //     }
      //   } else {
      //     window.localStorage.setItem(
      //       "challengeInfo",
      //       JSON.stringify(response.data)
      //     );
      //     this.$store
      //       .dispatch("challenge", { body: response.data })
      //       .then(() => {
      //         if (response.data.partner === null) {
      //           this.$router.push("/pending");
      //         } else {
      //           this.$router.push("/home");
      //         }
      //       });
      //   }
      // });
      var code = window.localStorage.getItem("pushToken");
      if(code == "helpertoken"){
        this.$router.push("/tutorial");
      }else{
        this.$router.push("/pending");
      }
    },
  },
  mounted() {
    this.division();
  },
};
</script>
